<template>
  <router-view></router-view>
</template>

<script>
export default {
  name: "Employees"
};
</script>

<style scoped>
</style>
